import { WS10_IS_HIDDEN } from '../constants';
import {
    ContentId,
    DiscountId,
} from '../enums/elementId';

/**
 * Select F&F element
 */
export const selectFnfElement = () => {
    const wrapperElement = document.querySelector(`.${ContentId.SUMMARYCARD_LEGALTEXT_WRAPPER}`);
    const pElements = wrapperElement?.querySelectorAll('p');

    return pElements && pElements[1];
};

/**
 * Select TV element
 */
export const selectTvElement = () =>
    document.getElementById(DiscountId.TV_CONNECT_PICKER_WRAPPER)?.classList.contains(WS10_IS_HIDDEN);
